import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import CarouselItem from './CarouselItem'; // Adjust the path as per your project structure

const Carousel = ({ items }) => {
  const options = {
    margin: 15,
    nav: false,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 4,
      },
    },
  };

  return (
    <OwlCarousel className="owl-theme ourvaluecarousel" {...options}>
      {items.map((item, index) => (
        <CarouselItem
          key={index}
          title={item.title}
          description={item.description}
          icon={item.icon}
        />
      ))}
    </OwlCarousel>
  );
};

export default Carousel;
